import React from 'react';
import { PriceCard } from './Shared';
export const PriceSection = () => {
  return <section id="precio" className="bg-familia-dark scroll-mt-4 pt-4 pb-12 md:pb-16 px-4 md:px-6" data-id="element-176" data-mp="3e9hjndtp04h7">
      <div className="max-w-7xl mx-auto" data-id="element-177" data-mp="39i9a8hsd4j41">
        <PriceCard data-id="element-178" data-mp="39h6iy8r4oenl" />
      </div>
    </section>;
};